export default __webpack_public_path__ + "static/media/Logo.09a57f3c.png";